import SimpleSelect from '@Components/Common/SimpleSelect';
import DialogTextField from '@Components/General/dialog-content/text-field';
import { Stack } from '@mui/material';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface StandardFilterProps {
    filterField: any;
    addFilter: any;
    control: Control<FieldValues>;
}

const StandardFilter = ({ filterField, control }: StandardFilterProps) => {
    const { t } = useTranslation();
    const { name, filterOptions } = filterField;

    const options = filterOptions.map(option => ({
        label: t(`controls:lookuplabels.${option}`),
        value: option,
    }));

    return (
        <Stack direction="row" spacing={1}>
            <Controller
                name="lookup"
                control={control}
                rules={{ required: true }}
                shouldUnregister
                render={({ field }) => (
                    <SimpleSelect
                        options={options}
                        sx={{ minWidth: 128, width: 128 }}
                        {...field}
                    />
                )}
            />
            <DialogTextField
                name={name}
                control={control}
                variant="filled"
                size="small"
                hiddenLabel
                placeholder={filterField.label}
            />
        </Stack>
    );
};

export default StandardFilter;
